import { parsePhoneNumber } from "libphonenumber-js";

/**
 * Normalizes login identifier for API: lowercase email or E.164 phone (+966 default).
 */
export function normalizeLoginIdentifier(raw) {
  const trimmed = String(raw ?? "").trim();
  if (!trimmed) {
    return trimmed;
  }

  if (trimmed.includes("@")) {
    return trimmed.toLowerCase();
  }

  try {
    const parsed = parsePhoneNumber(trimmed, "SA");
    if (parsed?.isValid()) {
      return parsed.format("E.164");
    }
  } catch {
    // Fall through to manual Saudi normalization.
  }

  return normalizeSaudiPhoneToE164(trimmed);
}

function normalizeSaudiPhoneToE164(raw) {
  let s = raw.replace(/[\s\-()]/g, "");

  if (!s) {
    return s;
  }

  if (s.startsWith("+")) {
    const digits = s.slice(1).replace(/\D/g, "");
    return `+${digits}`;
  }

  const digits = s.replace(/\D/g, "");
  if (!digits) {
    return "";
  }

  const defaultCountry = "966";

  if (digits.startsWith("0")) {
    return `+${defaultCountry}${digits.slice(1)}`;
  }

  if (digits.startsWith(defaultCountry)) {
    return `+${digits}`;
  }

  return `+${defaultCountry}${digits}`;
}
